// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServicesSection_servicesSection__1nPiN {
  margin: 76px 0 66px;
  text-align: left;
}
@media (max-width: 767px) {
  .ServicesSection_servicesSection__1nPiN {
    margin: 76px 0 0px;
  }
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_serviceTitle__N9VJT {
  color: #061c3d;
  font-family: Roboto;
  font-size: 48px;
  font-style: normal;
  font-weight: 800;
  line-height: 110%; /* 52.8px */
  margin-bottom: 12px;
}
@media (max-width: 767px) {
  .ServicesSection_servicesSection__1nPiN .ServicesSection_serviceTitle__N9VJT {
    font-size: 28px;
  }
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_serviceDescription__jzvsy {
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%; /* 28.8px */
  margin-bottom: 54px;
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu > div:nth-child(1) {
  background: rgb(230, 118, 87);
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu > div:nth-child(2) {
  background: rgb(192, 162, 184);
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu > div:nth-child(3) {
  background: rgb(95, 170, 189);
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu .ServicesSection_serviceCard__KMq\\+K {
  width: calc(33% - 13px);
  padding: 36px 25px 37px;
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 1023px) {
  .ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu .ServicesSection_serviceCard__KMq\\+K {
    width: calc(50% - 13px);
  }
}
@media (max-width: 580px) {
  .ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu .ServicesSection_serviceCard__KMq\\+K {
    width: 100%;
  }
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu .ServicesSection_serviceCard__KMq\\+K svg {
  width: 60px;
  height: 60px;
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu .ServicesSection_serviceCard__KMq\\+K .ServicesSection_cardContents__0wFnL {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu .ServicesSection_serviceCard__KMq\\+K .ServicesSection_cardContents__0wFnL button {
  background: #fff;
  font-size: 16px;
  color: #000;
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu .ServicesSection_serviceCard__KMq\\+K .ServicesSection_cardTitle__5ZU1O {
  color: #000;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 110%; /* 26.4px */
  margin: 24px 0;
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu .ServicesSection_serviceCard__KMq\\+K img {
  width: 100%;
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu .ServicesSection_serviceCard__KMq\\+K .ServicesSection_tickContent__1cpuH {
  display: flex;
  align-items: center;
  gap: 18px;
}
.ServicesSection_servicesSection__1nPiN .ServicesSection_servicesCards__K3Zqu .ServicesSection_serviceCard__KMq\\+K button {
  margin-top: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/ServicesSection/ServicesSection.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gBAAA;AACF;AAAE;EAHF;IAII,kBAAA;EAGF;AACF;AAFE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,mBAAA;AAIJ;AAHI;EARF;IASI,eAAA;EAMJ;AACF;AAJE;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,mBAAA;AAMJ;AAJE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,SAAA;AAMJ;AAJM;EACE,6BAAA;AAMR;AAJM;EACE,8BAAA;AAMR;AAJM;EACE,6BAAA;AAMR;AAHI;EACE,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kFAAA;EAKA,aAAA;EACA,sBAAA;EACA,8BAAA;AACN;AAAM;EAZF;IAaI,uBAAA;EAGN;AACF;AAFM;EAfF;IAgBI,WAAA;EAKN;AACF;AAJM;EACE,WAAA;EACA,YAAA;AAMR;AAJM;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AAMR;AALQ;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AAOV;AAJM;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,cAAA;AAMR;AAJM;EACE,WAAA;AAMR;AAJM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAMR;AAJM;EACE,gBAAA;AAMR","sourcesContent":[".servicesSection {\n  margin: 76px 0 66px;\n  text-align: left;\n  @media (max-width: 767px) {\n    margin: 76px 0 0px;\n  }\n  & .serviceTitle {\n    color: #061c3d;\n    font-family: Roboto;\n    font-size: 48px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 110%; /* 52.8px */\n    margin-bottom: 12px;\n    @media (max-width: 767px) {\n      font-size: 28px;\n    }\n  }\n  & .serviceDescription {\n    font-family: Roboto;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 160%; /* 28.8px */\n    margin-bottom: 54px;\n  }\n  & .servicesCards {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 20px;\n    & > div {\n      &:nth-child(1) {\n        background: rgb(230 118 87);\n      }\n      &:nth-child(2) {\n        background: rgb(192 162 184);\n      }\n      &:nth-child(3) {\n        background: rgb(95 170 189);\n      }\n    }\n    & .serviceCard {\n      width: calc(33% - 13px);\n      padding: 36px 25px 37px;\n      border-radius: 8px;\n      background: linear-gradient(\n        180deg,\n        rgba(0, 0, 0, 0.05) 0%,\n        rgba(0, 0, 0, 0) 100%\n      );\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      @media (max-width: 1023px) {\n        width: calc(50% - 13px);\n      }\n      @media (max-width: 580px) {\n        width: 100%;\n      }\n      & svg {\n        width: 60px;\n        height: 60px;\n      }\n      & .cardContents {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        height: 100%;\n        & button {\n          background: #fff;\n          font-size: 16px;\n          color: #000;\n        }\n      }\n      & .cardTitle {\n        color: #000;\n        font-family: Roboto;\n        font-size: 24px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 110%; /* 26.4px */\n        margin: 24px 0;\n      }\n      & img {\n        width: 100%;\n      }\n      & .tickContent {\n        display: flex;\n        align-items: center;\n        gap: 18px;\n      }\n      & button {\n        margin-top: 24px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"servicesSection": `ServicesSection_servicesSection__1nPiN`,
	"serviceTitle": `ServicesSection_serviceTitle__N9VJT`,
	"serviceDescription": `ServicesSection_serviceDescription__jzvsy`,
	"servicesCards": `ServicesSection_servicesCards__K3Zqu`,
	"serviceCard": `ServicesSection_serviceCard__KMq+K`,
	"cardContents": `ServicesSection_cardContents__0wFnL`,
	"cardTitle": `ServicesSection_cardTitle__5ZU1O`,
	"tickContent": `ServicesSection_tickContent__1cpuH`
};
export default ___CSS_LOADER_EXPORT___;
